import React, { useState } from 'react';
import { Button } from '@crisp/crisp-ui/cabbage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowUp, faSparkles } from '@crisp/crisp-ui/icons/classic/regular';
import styles from './AskBar.module.css';

interface AskBarProps {
  onOpenAssistant: (initialQuery?: string) => void;
  /** Set after a citation leaves the conversation; reopens it where the reader was. */
  onResumeAnswer?: () => void;
}

export const AskBar: React.FC<AskBarProps> = ({ onOpenAssistant, onResumeAnswer }) => {
  const [query, setQuery] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      onOpenAssistant(query.trim());
      setQuery('');
    } else {
      onOpenAssistant();
    }
  };

  return (
    <div className={styles.dock}>
      {onResumeAnswer && (
        <Button
          variant="outline"
          size="sm"
          className={styles.resume}
          onClick={onResumeAnswer}
          iconPrimary={<FontAwesomeIcon icon={faArrowLeft} />}
        >
          Back to AI answer
        </Button>
      )}
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.field}>
          <FontAwesomeIcon icon={faSparkles} className={`icon-slot ${styles.sparkle}`} />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Ask AI a question..."
            aria-label="Ask AI"
            className={styles.input}
          />
        </div>
        <Button
          type="submit"
          size="icon-sm"
          aria-label="Send question"
          iconPrimary={<FontAwesomeIcon icon={faArrowUp} />}
        />
      </form>
    </div>
  );
};
